import React, { useContext, useEffect, useState } from "react";
import LinkCommentsTable from "../components/Linkestan/LinkCommentsTable";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { context } from "../context/context";
import { NavLink } from 'react-router-dom';
import { Button } from "antd";

const LinkComments = () => {
    // state
    const [comments, setComments] = useState([]);
    const [title, setTitle] = useState();
    const [loading, setLoading] = useState(false);
    // context
    const { selectedLinkId } = useContext(context);
    // useEffect
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Link/${selectedLinkId}`)
            .then((res) => {
                setLoading(false);
                setTitle(res.data.result.title);
                setComments(res.data.result.comment);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [selectedLinkId]);

    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3>کامنت های {title}</h3>
                <NavLink to="/linkestan">
                    <Button type="primary" danger>
                        بازگشت
                    </Button>
                </NavLink>
            </div>
            <LinkCommentsTable comments={comments} loading={loading} />
        </>
    );
};

export default LinkComments;
